import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import MainApi from "../../../../../../services/mainApi.service";
import { IIntegrationRuleParams } from "../../../../../../models/integration-rule-param";
import { memo, useMemo, useState } from "react";
import { IntegrationRuleParam } from "./IntegrationRuleParamForm/IntegrationRuleParam";

interface IIntegrationRuleParamProps {
  busAutomationCode: number | null;
}

const INTEGRATION_RULE_PARAM_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleParam/";
const integrationRuleParamService = new MainApi<IIntegrationRuleParams>(
  INTEGRATION_RULE_PARAM_ROUTE,
);

const translationPath = "page.4uBus.integrationRule.integrationRuleParam.";

export const IntegrationRuleParamPage = memo(
  ({ busAutomationCode }: IIntegrationRuleParamProps) => {
    const { id: busIntegrationRuleId } = useParams();

    const { t } = useTranslation();

    const [iServiceForm, setIServiceForm] = useState(false);

    const [selectedId, setSelectedId] = useState<string>();

    const columns: GridColDef<IIntegrationRuleParams>[] = [
      {
        field: "_4uBusAutomationParam",
        headerName:
          t(translationPath + "inclusion_rule_type") || "Inclusion Rule Type",
        renderCell: (params) => {
          if (!params.value) return "-";
          return (
            <OverflowTooltip
              text={params.value.name}
              tooltip={params.value.name}
              textTransform="none"
              variant="body2"
            />
          );
        },
      },
    ];

    const handleAdd = () => {
      setIServiceForm(true);
    };

    const handleRowClick = (params: GridRowParams<IIntegrationRuleParams>) => {
      if (!params.row) return;
      setIServiceForm(true);
      setSelectedId(params.row.id);
    };

    const handleBack = () => {
      setSelectedId(undefined);
      setIServiceForm(false);
    };

    const params = useMemo(() => {
      return {
        _4uBusIntegrationRuleId: busIntegrationRuleId,
      };
    }, [busIntegrationRuleId]);

    return (
      <Box sx={{ height: 600, width: "100%" }}>
        {iServiceForm && (
          <Box
            sx={(t) => ({
              p: 1,
              px: 10,
              height: "100%",
              overflow: "auto",
              backgroundColor: t.palette.background.default,
              borderRadius: 1,
            })}
          >
            <IntegrationRuleParam
              id={selectedId}
              busIntegrationRuleId={busIntegrationRuleId}
              busAutomationCode={busAutomationCode}
              onBackButton={handleBack}
            />
          </Box>
        )}
        {!iServiceForm && (
          <Box height={600}>
            <Table<IIntegrationRuleParams>
              showDefaultMacroFilters={false}
              service={integrationRuleParamService}
              serviceProps={params}
              columns={columns}
              title={t(translationPath + "integration_rule_params")}
              searchInput
              onAdd={handleAdd}
              onRowClick={handleRowClick}
              searchInputPlaceHolder={t(translationPath + "search")}
              addButtonLabel={
                t(translationPath + "add_integration_rule_param") ||
                "Add Parameter"
              }
              confirmOptions={{
                title: t(translationPath + "confirm.title"),
                description: t(translationPath + "confirm.description"),
                confirmationButtonProps: {
                  variant: "contained",
                },
              }}
            />
          </Box>
        )}
      </Box>
    );
  },
);
